import { TThunkAction } from '../../types/redux';
import {
  fetchExistsUserEstimationScoreFact,
  IExistsUserEstimationScoreFactResponse200 as IRes200,
  IExistsUserEstimationScoreFactResponse400 as IRes400,
} from '../../repositories/price-estimator/v1/exists-user-estimation-score-fact';
import { setRateOurEstimationScreen, setRateOurIsScoreFact, toggleRateOurEstimationLoadingBlock } from './actions';
import { BadRequestError } from '@cian/valuation-utils-component';
import { ERateScreen } from '../../types/redux/rateOurEstimation';
import {
  fetchPublicSuburbanV1ExistsUserEstimationScoreFact,
  IPublicSuburbanV1ExistsUserEstimationScoreFactResponse200 as ISuburbanRes200,
  IPublicSuburbanV1ExistsUserEstimationScoreFactResponse400 as ISuburbanRes400,
} from '../../repositories/price-estimator/suburban/v1/exists-user-estimation-score-fact';
import { ECategory } from '../../../shared/repositories/price-estimator/entities/estimation_suburban_score_fact/EstimationSuburbanScoreSchema';

export function checkExistRateOurEstimation(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { area, roomsCount, houseId },
      page: { dealType },
    } = getState();
    const { httpApi, logger } = context;

    if (!area || !roomsCount || !houseId) {
      return;
    }

    dispatch(toggleRateOurEstimationLoadingBlock(true));
    dispatch(setRateOurEstimationScreen(ERateScreen.Form));

    const parameters = {
      area,
      roomsCount,
      houseId,
      dealType,
    };

    try {
      const res = await fetchExistsUserEstimationScoreFact<IRes200, IRes400>({
        httpApi,
        parameters,
      });

      if (res.statusCode === 200) {
        dispatch(setRateOurIsScoreFact(res.response.exists));

        return;
      }

      throw new BadRequestError({
        domain: 'checkExistRateOurEstimation.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      logger.error(error, {
        message: 'Failed get price-estimator/v1/exists-user-estimation-score-fact',
        ...parameters,
      });
    } finally {
      dispatch(toggleRateOurEstimationLoadingBlock(false));
    }
  };
}

export function checkSuburbanExistRateOurEstimation(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { address, category, landArea, houseArea, houseId },
    } = getState();
    const { httpApi, logger } = context;

    dispatch(toggleRateOurEstimationLoadingBlock(true));
    dispatch(setRateOurEstimationScreen(ERateScreen.Form));

    const parameters = {
      address,
      category: category as unknown as ECategory,
      houseArea,
      houseId,
      landArea: landArea as number,
    };

    try {
      const res = await fetchPublicSuburbanV1ExistsUserEstimationScoreFact<ISuburbanRes200, ISuburbanRes400>({
        httpApi,
        parameters,
      });

      if (res.statusCode === 200) {
        dispatch(setRateOurIsScoreFact(res.response.exists));

        return;
      }

      throw new BadRequestError({
        domain: 'checkSuburbanExistRateOurEstimation.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      logger.error(error, {
        message: 'Failed get price-estimator/suburban/v1/exists-user-estimation-score-fact/',
        ...parameters,
      });
    } finally {
      dispatch(toggleRateOurEstimationLoadingBlock(false));
    }
  };
}
